
import { defineComponent, ref } from 'vue';
import { onClickOutside } from '@vueuse/core';

export default defineComponent({
  setup() {
    const cMenu = ref();
    const isShow = ref(false);

    function toggleMenu() {
      //
    }

    function close() {
      isShow.value = false;
    }

    onClickOutside(cMenu, close);

    return {
      cMenu,
      isShow,
      toggleMenu,
    };
  },
});
